import { styled, Switch } from '@mui/material';

const glyph = (d) => `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='${d}'/></svg>")`;

const StyledSwitch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    backgroundColor: (theme.vars || theme).palette.neutral.main,
    opacity: 1,
    // Masks painted with `neutral.contrastText`: a data-URI SVG can't read a CSS variable.
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
      backgroundColor: (theme.vars || theme).palette.neutral.contrastText,
      mask: 'var(--glyph) center / 16px 16px no-repeat',
    },
    '&::before': {
      '--glyph': glyph('M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z'),
      left: 12,
    },
    '&::after': {
      '--glyph': glyph('M19,13H5V11H19V13Z'),
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
}));

export default StyledSwitch;
